export class AutoTagModelDialogOpenOptions {
    openType: AutoTagModelDialogType;
}

export enum AutoTagModelDialogType {
    CreateModel = 'Create Model'
}
